import type { FaireProductEntity } from "../../entity_types/product";

export const p_z8e6hhcaea: FaireProductEntity = {
  token: "p_z8e6hhcaea",
  type: "product",
  name: "Kohakutou Crystal Gummies",
  brandToken: "b_bzykasyg9b",
  brandName: "Artistry Candies, LLC",
  imageUrl: "https://cdn.faire.com/fastly/65cc773f8d1880bacc207d5ab2bdfcfda7c6ac9fe576990e0dab6631907ccbbf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19bdfbe2c2376adb310899ea638cc3cfaec905cdd7591d96800fcfe288218c31.jpeg",
    "https://cdn.faire.com/fastly/7cccd41e4b17cd98e13160741d5190a6b3054c012f391fd6def32da3c94c4446.jpeg",
    "https://cdn.faire.com/fastly/a455bc34c54c2191ce2981268ef7ed61e2c5a44802a8306beb2532fbe6fb073a.jpeg",
    "https://cdn.faire.com/fastly/8df596eed39bd777f8912c6e8e5c6b804530780cedbf05069a568f1e1b85c4b4.jpeg",
    "https://cdn.faire.com/fastly/9b641df705039d16614328be8c132748adfca27d1888160990f563cf0564fa9f.jpeg",
    "https://cdn.faire.com/fastly/6972513d913bdcc8bb9c61d1d3a1754e88756dc5ed0067618aed7503afa0611c.jpeg",
    "https://cdn.faire.com/fastly/f08f780418265452e31542896a2282d143e7f6f5bb556ad05d339060786a3937.jpeg"
  ],
  priceDollars: 4.85,
  description: "A unique candy that has a crusty outer shell then very soft (almost melts in your mouth) middle gummy.  Comes in a 2”x2” square clear box (3 oz) with bow.  ",
  tags: [],
  msrpDollars: 9.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:54.593Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
